import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import { FetchDevices } from "../../api/api";
import ErrorToast from "../toasts/ErrorToast";

const AddDeviceModal = () => {
  const { setAddDeviceModal } = useContext(Context);
  const [str, setStr] = useState("");

  const modalName = useRef();
  const closeButton = useRef();

  useEffect(() => {
    setAddDeviceModal(modalName);
  }, []);

  const handlePasteText = () => {
    if (navigator.clipboard && navigator.clipboard.readText) {
      navigator.clipboard
        .readText()
        .then((text) => {
          setStr(text);
        })
        .catch((err) => {
          console.error("Clipboard access failed:", err);
          alert(
            "خطا در دسترسی به کلیپ‌بورد. لطفاً از Ctrl+V استفاده کنید یا سایت را روی HTTPS اجرا کنید."
          );
        });
    } else {
      alert(
        "مرورگر شما یا اتصال فعلی اجازه دسترسی به کلیپ‌بورد را نمی‌دهد. لطفاً از Ctrl+V استفاده کنید."
      );
    }
  };

  const handleFetchDevices = () => {
    if (!str || str == "") {
      return ErrorToast("کد شناسایی را وارد کنید");
    }
    FetchDevices({ str })
      .then(({ data }) => {
        closeButton.current.click();
        window.location.reload();
      })
      .catch((jqXHR) => {
        let errorMessage = "";
        switch (jqXHR.response.status) {
          case 400:
            for (var key in jqXHR.response.data) {
              if (jqXHR.response.data.hasOwnProperty(key)) {
                return ErrorToast(jqXHR.response.data[key]);
              }
            }
            errorMessage = "An unexpected error occurred. Please try again.";
        }
      });
  };
  return (
    // Modal
    <div
      className="modal fade"
      id="backupModal"
      tabIndex="-1"
      aria-labelledby="backupModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="backupModalLable">
              افزودن دستگاه
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div>
              <label htmlFor="defaultFormControlInput" className="form-label">
                در صورت داشتن کد شناسایی آن را وارد کنید در غیراینصورت پشتیبان
                را بازگردانی کنید
              </label>
              <input
                type="text"
                className="form-control"
                id="defaultFormControlInput"
                value={str}
                onChange={(e) => setStr(e.target.value)}
              />
            </div>
            <button
              type="button"
              className="btn btn-outline-secondary mt-2"
              onClick={handlePasteText}
            >
              PASTE
            </button>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success-app mb-2"
              onClick={handleFetchDevices}
            >
              تایید
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDeviceModal;
